module.exports = __webpack_public_path__ + "static/joris-voorn-9f0550dfdf74ada92fd80beab2ee985a.png";